<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;height: 85%;overflow-y: hidden">
    <el-tabs type="border-card">
      <el-tab-pane label="属性配置">
        <a-spin :spinning="confirmLoading">
          <a-form :form="form">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="展示样式">
                  <el-select v-model="form.direction" placeholder="请选择">
                    <el-option label='横向步骤条' value='horizontal' key="1"></el-option>
                    <el-option label='纵向步骤条' value='vertical' key="2"></el-option>
                  </el-select>
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="激活步骤">
                  <a-input v-model="form.active" placeholder="请输入数字"/>
                </a-form-item>
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="步骤间隔">
                  <a-input v-model="form.space" placeholder="不填可自适应"/>
                </a-form-item>
          </a-form>
        </a-spin>
      </el-tab-pane>
      <el-tab-pane label="步骤配置">
        <div align="center"><el-button type="primary" size="medium" @click="addDispose()">添加步骤条</el-button></div><br/><br/>
        <draggable class="draggable" v-model="disposeDatas" dragable="true"  :options="{animation: 700,}">
          <a-row class="form-row"  v-for="(dData,index) in disposeDatas" :key="index">
            <a-col :span="7">
              <a-form-item :label="'步骤'+(index+1)+'名称'" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="dData.title"/>
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="数据值" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="dData.flag"/>
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="描述文字" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="dData.description"/>
              </a-form-item>
            </a-col>
            <a-col :span="3">
              <el-button type="danger" round size="mini" @click.prevent="removeDomain(dData)">删除</el-button>
            </a-col>
          </a-row>
        </draggable>
      </el-tab-pane>
    </el-tabs>

  </a-modal>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    name: "eleStepSimple",
    components: {
      draggable
    },
    data() {
      return {
        conKey: '',
        componentFlag: '',
        title: '步骤条配置',
        visible: false,
        confirmLoading: false,
        labelCol: {
          xs: {span: 10},
          sm: {span: 8},
        },
        wrapperCol: {
          xs: {span: 10},
          sm: {span: 12},
        },
        form: {},
        disposeDatas: []
      }
    },
    methods: {
      removeDomain(item) {
        let index = this.disposeDatas.indexOf(item);
        if (index !== -1) {
          this.disposeDatas.splice(index, 1)
        }
      },
      addDispose() {
        this.disposeDatas.push({title: "", flag: "", description: ""})
      },
      edit(conKey, componentFlag) {
        this.visible = true;
        this.conKey = conKey;
        this.componentFlag = componentFlag;
      },
      handleOk() {
        this.visible = false;
        this.$emit('setComponentData',
          JSON.stringify(Object.assign(this.form, {params: JSON.stringify(this.disposeDatas)})), this.conKey,
          this.componentFlag);
      },
      handleCancel() {
        this.visible = false;
      },
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/lib/editMoudle/eleStepSimple.vue